import Box from "@mui/material/Box";
import { memo, PropsWithChildren } from "react";

const BrokerAuthRedirectContainer: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
                alignContent: 'center'
            }}
        >
            <p style={{ fontSize: '24px', color: 'black', paddingTop: '24px' }}>{'Logging in'}</p>
            {children}
        </Box>
    );
};

export default memo(BrokerAuthRedirectContainer);